module.exports = __webpack_public_path__ + "img/introduction02_all_01.ecf7b1c6.png";